import * as React from 'react';
import { createComponent } from '@lit/react';
import type { EventName } from '@lit/react';
import { Switch as SpSwitch } from '@spectrum-web-components/switch';

import '@spectrum-web-components/switch/sp-switch.js';

export const Switch = createComponent({
    displayName: 'Switch',
    elementClass: SpSwitch,
    react: React,
    tagName: 'sp-switch',
    events: {
        change: 'change' as EventName<Event>, // Announces a change in the `checked` property of a Switch
    },
});

export type SwitchType = EventTarget & SpSwitch;
